import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user.model';

export const setStudent = createAction('[Admin] Set Student', props<{ studentId: string }>());
export const setStudentSuccess = createAction(
  '[Admin] Set Student Success',
  props<{ student: User }>()
);
export const setStudentFailure = createAction(
  '[Admin] Set Student Failure',
  props<{ error: any }>()
);

export const clearStudent = createAction('[Admin] Clear Student');
